<script setup lang="ts">
import type { StrapiMedia, StrapiMediaResponsiveFormats } from '@nimbus/types'
import { computed, useStrapiMedia } from '#imports'

interface StrapiMediaProps {
    media: StrapiMedia
    responsiveSize?: StrapiMediaResponsiveFormats
    provider?: string
    preset?: string
    width?: string | number
    height?: string | number
    altText?: string
    sizes?: string
}

const props = defineProps<StrapiMediaProps>()

const { getStrapiMediaUrl, getStrapiMediaAttr } = useStrapiMedia()

const mediaAttr = computed(() => getStrapiMediaAttr(props.media, props.responsiveSize))
</script>

<template>
    <NuxtImg
        v-if="mediaAttr"
        :provider="provider"
        :preset="preset"
        :src="getStrapiMediaUrl(mediaAttr?.url)"
        :alt="altText || mediaAttr?.alternativeText"
        :width="width || mediaAttr?.width"
        :sizes="sizes"
        densities="x1"
        :height="height || mediaAttr?.height"
        loading="lazy"
        decoding="async"
    />
</template>
